import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  template: ''
})
export abstract class UserCreateComponent extends BaseFormComponent implements OnInit {

  @Input('selectedRows') selectedRows: any;

  accounts: any;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'user';
  }

  async customize(field) {
    if (this.isEdit) {
      switch (field.name) {
        case 'account_id':
          field.type.name = 'text';
          field.type.readOnly = true;
          field.type.option = undefined;
          break;
        case 'username':
          field.type.readOnly = true;
          break;

        default:
          break;
      }
    }
    await super.customize(field);
  }

  getBody(): any {
    const body = super.getBody();
    body['service_type'] = this.subentityName.toUpperCase();
    return body;
  }

  async valueChanged(e) {
    if (e.value && e.previousValue && e.value != e.previousValue) {
      switch (e.element.id) {
        case 'tags':
          if (!(this.roles.includes('SALES_MNG') || this.roles.includes('CUSTOMER_CARE_MNG')) && e.value.length < e.previousValue.length){
            setTimeout(() => {
              this.changeValue('tags', e.previousValue);
            }, 100);
          }
        break;
        default:
          await super.valueChanged(e);
          break;
      }
    }
  }


}
